export default __webpack_public_path__ + "assets/images/df203a33e87aed7bc4a9ca5a60c3505d.jpg";